import { Modal } from 'semantic-ui-react';
import styled from 'styled-components';

export const ModalContainer = styled(Modal)`
  .header {
    display: flex !important;
    justify-content: space-between;
  }
`;
